import { setErrors, setLoading, setPolicies } from '../dashboard/policies/policyReducer';
import { API } from '../../../utils/api/index';
import { setCustomer } from '../customer/customerReducer';
import { setGoPaperlessErrors } from '../user-profile/profileReducer';
import { setPolicyPreference } from '../policy-details/policyDetailsReducer';

export const saveCustomerDeliveryPreferences = (
  systemId,
  customerRevision,
  preferredDeliveryMethod,
  notify,
) => {
  return (dispatch) => {
    let body = {
      preferredDeliveryMethod,
      _revision: customerRevision,
    };
    if (customerRevision === null) {
      API.get(`policies/${policy.policyRef}`).then((response) => {
        body._revision = response.data._revision;
      });
    }
    API.patch('customers/' + systemId, body)
      .then((response) => {
        dispatch(setCustomer(response.data));
        notify(
          `Your delivery preferences have been updated for all other customer communications`,
          {
            variant: 'success',
            anchorOrigin: {
              horizontal: 'center',
              vertical: 'top',
            },
          },
        );
      })
      .catch((err) => {
        notify(
          `Your delivery preferences were unable to be updated for all other customer communications ${err?.response?.data?.message}`,
          {
            variant: 'error',
            anchorOrigin: {
              horizontal: 'center',
              vertical: 'top',
            },
          },
        );
      })
      .finally(() => dispatch(setLoading(false)));
  };
};
const mapBasicPolicyData = (mappedPolicy, basicPolicy) => {
  mappedPolicy.providerRef = basicPolicy.providerRef;
  mappedPolicy.policyNumber = basicPolicy.policyNumber;
  mappedPolicy.effectiveDt = basicPolicy.effectiveDt;
  mappedPolicy.expirationDt = basicPolicy.expirationDt;
  mappedPolicy.statusCd = basicPolicy.statusCd;
  mappedPolicy.displayDescription = basicPolicy.displayDescription;
  mappedPolicy.description = basicPolicy.description;
};

const updatePoliciesWithCurrentTerm = (policies, dispatch, apiResponseSizeLimit) => {
  let updatedPolicies = [];

  const maxSize = Math.min(policies.length, apiResponseSizeLimit);
  // iterate over all policies
  for (let i = 0; i < maxSize; i++) {
    const currentTermPolicyResponse = policies[i].policyMini;

    // if policy is effective in the future, add the current term policy
    const currentTermPolicy = {};
    currentTermPolicy.policyRef = currentTermPolicyResponse.systemId;
    const miniBasicPolicy = policies[i]?.policyMini?.basicPolicy;
    mapBasicPolicyData(
      currentTermPolicy,
      miniBasicPolicy ? miniBasicPolicy : currentTermPolicyResponse.basicPolicy,
    );
    currentTermPolicy.insured = currentTermPolicyResponse.insured;
    updatedPolicies.push(currentTermPolicy);
  }
  dispatch(setPolicies(updatedPolicies));
};
export const getPoliciesWithLatestTerm = (
  customerRef,
  createdSinceDate,
  policiesCountLimit,
  policyStatusCd,
  apiResponseSizeLimit,
) => {
  return (dispatch) => {
    dispatch(setPolicies([]));
    dispatch(setLoading(true));
    if (API) {
      return (
        API.get(
          `policies?customerId=${customerRef}&createdSinceDt=${createdSinceDate}&limit=${policiesCountLimit}&status=${policyStatusCd}`,
        )
          // get all policies with the latest term for the customer

          .then((response) => {
            if (
              response.data.policyListItems === undefined ||
              response.data.policyListItems.length === 0
            ) {
              dispatch(setPolicies([]));
              dispatch(setLoading(false));
              return;
            }

            // update with current terms
            updatePoliciesWithCurrentTerm(
              response.data.policyListItems,
              dispatch,
              apiResponseSizeLimit,
            );
          })
          .catch((err) => dispatch(setErrors(err.message)))
      );
    }
  };
};
const patchPolicy = async (policyRef, body) => {
  await API.patch('policies/' + policyRef, body);
};
export const updateMultipleDeliveryPreferences = (policiesToUpdate, notify) => {
  return async (dispatch) => {
    dispatch(setLoading(true));

    // retrieve policy revision, then patch it
    for (const policy of policiesToUpdate) {
      let body = {
        insured: {
          id: policy.insured.id,
          preferredDeliveryMethod: policy.newPreference,
        },
        _revision: policy._revision,
      };
      if (!policy._revision) {
        console.log(policy);
        await API.get(`policies/${policy.policyRef}`)
          .then((response) => {
            return response.data._revision;
          })
          .then(async (revision) => {
            body._revision = revision;

            await patchPolicy(policy.policyRef, body).then(() => {
              dispatch(setPolicyPreference(policy.newPreference));
              notify(`Your policy preferences have been updated for ${policy.policyNumber}`, {
                variant: 'success',
                anchorOrigin: {
                  horizontal: 'center',
                  vertical: 'top',
                },
              });
            });
          })
          .catch((err) => {
            dispatch(setGoPaperlessErrors(err.message));
          });
      } else {
        await patchPolicy(policy.policyRef, body)
          .then(() => {
            dispatch(setPolicyPreference(policy.newPreference));
            notify(`Your policy preferences have been updated for ${policy.policyNumber}`, {
              variant: 'success',
              anchorOrigin: {
                horizontal: 'center',
                vertical: 'top',
              },
            });
          })
          .catch((err) => {
            console.log(err);
            dispatch(setGoPaperlessErrors(err.message));
            notify(
              `Your policy preferences were unable to be updated for ${policy.policyNumber} ${err?.response?.data?.message}`,
              {
                variant: 'error',
                anchorOrigin: {
                  horizontal: 'center',
                  vertical: 'top',
                },
              },
            );
          });
      }
    }
  };
};
